// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"categories_sectionTitle__1JWpv","categoriesList":"categories_categoriesList__2c3h1","category":"categories_category__1UPgD","showMore":"categories_showMore__1ft3g"};